import { Component, inject, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from '@services/user.service';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from './auth/auth.service';
import { TranslationService } from './services/translation.service';

ModuleRegistry.registerModules([AllCommunityModule]);
@Component({
  selector: 'md-app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [MatIconRegistry]
})
export class AppComponent implements OnInit {
  userService = inject(UserService);
  translationService = inject(TranslationService);
  private authService = inject(AuthService);

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private readonly oidcSecurityService: OidcSecurityService
  ) {
    const icons = ['user', 'customer', 'partner', 'product', 'service', 'info'];
    icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(icon, this.domSanitizer.bypassSecurityTrustResourceUrl(`../icons/${icon}.svg`));
    });
  }
  title = 'MasterData';

  ngOnInit() {
    this.authService.initialize();

    // Authentication is handled automatically by withAppInitializerAuthCheck()
    // Listen for authentication state changes and get user data separately
    this.oidcSecurityService.isAuthenticated().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        // Get user data when authenticated
        this.oidcSecurityService.getUserData().subscribe(userData => {
          if (userData) {
            this.userService.setUserData(userData);
          }
        });
      }
    });
  }
}
